// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-70ee9343] .modal-backdrop{opacity:.3}[data-v-70ee9343] .modal-header{padding:1rem 3rem 0}[data-v-70ee9343] .close-btn{min-width:unset;padding:0;width:35px;height:35px}[data-v-70ee9343] .modal-footer{padding:0 3rem 1rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
